import { render, staticRenderFns } from "./CZY005_Result.vue?vue&type=template&id=6b3157b7&scoped=true&"
import script from "./CZY005_Result.vue?vue&type=script&lang=js&"
export * from "./CZY005_Result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3157b7",
  null
  
)

export default component.exports